export default {
  vehicle: "vehicle",
  vehicleTypes: "vehicle-types",
  addNewVehicle: "vehicle/new",
  drivers: "available-riders",
  addNewDriver: "partners/add-rider",

  trip: "trip"
};
